// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"7a743919","266":"4013aa2a","611":"7176dcb4"}[chunkId] + ".chunk.js";
};